import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as config from '../backend.config';
import { Page } from '../../../shared/filters/filters';

// ----------------------------------------------
// Service for Publisher / ContentLockers
// Component:
// ----------------------------------------------

//const ADDRS_API = config.COMP_API + '/pub';
const ADDRS_API = config.API;
const CONTENT_KEY1 = 'content-pub-selected';
const CONTENT_KEY2 = 'content-pub-page';

// API description for all commnication with BACK-END for accounts management
// ----------------------------------------------
// BACK-END API
// ----------------------------------------------


const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})

export class LockerService {
  constructor(private http: HttpClient) { }

  // CONTENT LOCKERS
  // pobranie listy wszystkich content lockersów
  getAllContentLocker(data: any): Observable<any> {
    return this.http.post(ADDRS_API + `/contentlockers`, data);
  }

  // utworzenie nowego content lockera
  newContentLocker(data: any): Observable<any> {
      return this.http.post(ADDRS_API + `/contentlockers/create-new`, data);
    }

  // usunięcie pojedynczego konkretnego pełnego lockera
  deleteContentLocker(id: any): Observable<any> {
    return this.http.delete(ADDRS_API + `/contentlockers/` + `${id}`);
  }

  // pobranie pojedynczego konkretnego pełnego lockera
  getContentLocker(id: any): Observable<any> {
    return this.http.get(ADDRS_API + `/contentlockers/` + `${id}`);
  }

  // update pojedynczego konkretnego pełnego lockera
  updateContentLocker(id: any, data: any): Observable<any> {
    return this.http.put(ADDRS_API + `/contentlockers/` + `${id}`, data);
  }


  // -----------------------------------------------------------------------
  // FILE LOCKERS
  // pobranie listy wszystkich file lockersów
  getAllFileLocker(data: any): Observable<any> {
    return this.http.post(ADDRS_API + `/filelockers`, data);
  }

  // utworzenie nowego content lockera
  newFileLocker(data: any): Observable<any> {
      return this.http.post(ADDRS_API + `/filelockers/create-new`, data);
    }

  // update pojedynczego konkretnego file lockera
  updateFileLocker(id: any, data: any): Observable<any> {
      return this.http.put(ADDRS_API + `/filelockers/` + `${id}`, data);
    }

  // usunięcie pojedynczego konkretnego pełnego lockera
  deleteFileLocker(id: any): Observable<any> {
    return this.http.delete(ADDRS_API + `/filelockers/` + `${id}`);
  }

  // ----------------------------------------------
  // OBSŁUGA FILTRÓW
  // PUBLISHER-OFFERS
  public saveSelected(id: number, filter: any): void {
      switch(id){
        case 1: // selected
          window.sessionStorage.removeItem(CONTENT_KEY1);
          window.sessionStorage.setItem(CONTENT_KEY1, JSON.stringify(filter));
          break;

        case 2: // page
          window.sessionStorage.removeItem(CONTENT_KEY2);
          window.sessionStorage.setItem(CONTENT_KEY2, JSON.stringify(filter));
      }
  }

  public getSelected(id: number): any {
      switch(id) {
        case 1: // selected
          const filter1 = window.sessionStorage.getItem(CONTENT_KEY1);
          if(filter1)
          {
            return JSON.parse(filter1);
          }
          return null;

        case 2: // page
          const filter2 = window.sessionStorage.getItem(CONTENT_KEY2);
          if(filter2)
          {
            return JSON.parse(filter2);
          }
          return null;
      }
  }
}
